
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","baseProfile":"tiny","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 23.2","overflow":"visible"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M2.7 17.099c.1-.2 0-.4-.2-.5h-.1l-1.4-.4c-.2 0-.3-.2-.3-.4 0-.1 0-.1.1-.1l2.6-4.5c.1-.2.1-.4-.1-.5l-.1-.1-2.4-.7c-.2 0-.3-.2-.3-.4 0-.1 0-.1.1-.2l5.8-8.8c.2-.2.5-.4.8-.3l6.4 1.7c.2 0 .3.2.3.3 0 .1 0 .1-.1.2L8 8.199c-.1.1-.1.3 0 .4 0 .1.1.1.2.1l2.5.6c.2 0 .3.1.3.3 0 .1 0 .1-.1.2l-3.9 5.3c-.1.1-.1.3 0 .4 0 .1.1.1.2.1l1.4.4c.3.1.3.3.1.4l-8.3 6.5c-.2.2-.3.1-.2-.2l2.5-5.6z"}})])
          )
        }
      }
    